export default {
	route:
	{
		start: "Start",
		customers: "Institutions",
		agreements: "Agreements",
		orders: "Orders",
		produkter: "Products"
	},
	header:
	{
		logOut: "Log out",
		myprofile: "My profile"
	},
	login:
	{
		title: "Login"
	}
}
